<ds-breadcrumb [breadcrumbs]="breadcrumbs$ | async"></ds-breadcrumb>
<app-add-digital-property [homeLink]="['../../']" [tenantId]="tenantId"></app-add-digital-property>
